module.exports = __webpack_public_path__ + "img/bul_layout_footer_common.1bc1fb06.svg";